/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { GetNationalityResponse } from '../models/get-nationality-response';

/**
 * nationality apis
 */
@Injectable({ providedIn: 'root' })
export class NationalityService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllNationality()` */
  static readonly GetAllNationalityPath = '/api/v1/nationality';

  /**
   * Get list of nationality.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllNationality()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllNationality$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields:
       * - nationality
       * - code
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetNationalityResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      NationalityService.GetAllNationalityPath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('search', params.search, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetNationalityResponse>;
        })
      );
  }

  /**
   * Get list of nationality.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllNationality$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllNationality(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields:
       * - nationality
       * - code
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<GetNationalityResponse> {
    return this.getAllNationality$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<GetNationalityResponse>
        ): GetNationalityResponse => r.body
      )
    );
  }
}
